export const baseTranslations = {
  FR: {
    dashboard: 'Mise à jour',
    instagram_accounts: 'Comptes Instagram',
    referral: 'Parrainage',
    help_support: 'Aide et support',
    my_account: 'Mon compte',
    logout: 'Déconnexion',
    add_account: 'Ajouter un compte',
    light_mode: 'Mode clair',
    dark_mode: 'Mode sombre',
    select_account: 'Sélectionnez un compte Instagram pour voir les détails',
    active: 'Actif',
    paused: 'En pause',
    welcome: 'Bienvenue sur votre Mise à jour',
    invite_friends: 'Invitez vos amis et gagnez des récompenses',
    manage_info: 'Gérez vos informations personnelles',
    search_accounts: 'Rechercher des comptes...',
    search_targets: 'Rechercher des comptes Instagram...',
    add_multiple_targets:
      'Ajouter plusieurs cibles (séparées par des virgules)',
    no_results: 'Aucun résultat trouvé',
    selected_targets: 'Cibles sélectionnées',
    followers: 'Abonnés',
    following: 'Abonnements',
    posts: 'Publications',
    popular: 'Populaire',
    current_plan: 'Plan actuel',
    change_plan: 'Changer de plan',
    start_now: 'Commencer gratuitement',
    cancel_subscription: 'Annuler mon abonnement',
    cancel_subscription_confirm:
      'Êtes-vous sûr de vouloir annuler votre abonnement ?',
    cancel_subscription_warning:
      'Votre abonnement sera annulé à la fin de la période en cours.',
    per_month: '/mois',
    welcome_dm: 'Message de bienvenue',
    welcome_dm_placeholder: 'Écrivez votre message de bienvenue...',
    welcome_dm_description:
      "Vous pouvez utiliser les variables suivantes dans vos messages personnalisés :\n{{username}} pour le nom d'utilisateur, \n{{full_name}} pour le nom complet (ou nom d'utilisateur si le nom complet n'est pas renseigné)\n{{first_name}} pour le prénom du destinataire.",
    save: 'Enregistrer',
    welcome_dm_saved: 'Message enregistré avec succès',
    add_instagram_account: 'Ajouter un compte Instagram',
    select_plan: 'Sélectionner un plan',
    connect_account: 'Connecter votre compte',
    username: "Nom d'utilisateur",
    password: 'Mot de passe',
    connect: 'Connecter',
    back: 'Retour',
    next: 'Suivant',
    username_required: "Le nom d'utilisateur est requis",
    password_required: 'Le mot de passe est requis',
    delete_account_confirm: 'Supprimer le compte',
    delete_account_warning:
      'Êtes-vous sûr de vouloir supprimer ce compte ? Cette action est irréversible.',
    cancel: 'Annuler',
    delete: 'Supprimer',
    add: 'Ajouter',
    verifying: 'Vérification...',
    connecting: 'Connexion...',
    please_wait: 'Veuillez patienter...',
    continue_now: 'Continuer maintenant',
    return_to_dashboard: 'Retour à la Mise à jour',
    overview: "Vue d'ensemble",
    targets: 'Cibles',
    plans: 'Plans',
    welcome_dm_tab: 'Message de bienvenue',
    close_friends: 'Amis proches',
    close_friends_active:
      "La fonctionnalité amis proches est bien activée et fonctionne normalement, vous n'avez rien à faire.",
    close_friends_description:
      "L'ajout des abonnés se fait progressivement jusqu'à un maximum de 7 500 abonnés, conformément à la limite fixée par Instagram. Une fois ce seuil atteint, l'ensemble des abonnés est intégré de manière aléatoire dans la liste des amis proches, garantissant ainsi une rotation équitable et la visibilité pour chacun à terme.",
    settings: 'Paramètres',
    account_settings: 'Paramètres du compte',
    new_password: 'Nouveau mot de passe',
    enter_new_password: 'Entrez le nouveau mot de passe',
    update_password: 'Mettre à jour le mot de passe',
    updating: 'Mise à jour...',
    password_updated: 'Mot de passe mis à jour avec succès',
    profile_updated: 'Profil mis à jour avec succès',
    update_password_error: 'Erreur lors de la mise à jour du mot de passe',
    followers_evolution: 'Évolution des abonnés',
    followers_gained: 'Abonnés gagnés',
    daily_gains: 'Gains quotidiens',
    free_account: 'Compte gratuit',
    select_payment: 'Sélectionner un moyen de paiement',
    card_information: 'Informations de carte',
    card_number: 'Numéro de carte',
    expiration: 'Expiration',
    cvc: 'CVC',
    pay: 'Payer',
    processing: 'Traitement...',
    invalid_plan: 'Plan invalide',
    checkout_error:
      'Une erreur est survenue lors du paiement. Veuillez réessayer.',
    monthly: 'Mensuel',
    annual: 'Annuel',
    save_annually: "Économisez jusqu'à {savings} par an",
    personal_info: 'Informations personnelles',
    email: 'Adresse e-mail',
    first_name: 'Prénom',
    last_name: 'Nom',
    phone: 'Téléphone',
    save_changes: 'Enregistrer les modifications',
    saving: 'Enregistrement...',
    change_password: 'Changer le mot de passe',
    current_password: 'Mot de passe actuel',
    confirm_password: 'Confirmer le mot de passe',
    changing: 'Modification...',
    password_min_length: 'Le mot de passe doit contenir au moins 6 caractères',
    passwords_not_match: 'Les mots de passe ne correspondent pas',
    sign_in: 'Se connecter',
    connect_instagram: 'Connectez votre compte Instagram',
    enter_instagram_username:
      "Entrez votre nom d'utilisateur Instagram pour commencer",
    instagram_username: "Nom d'utilisateur Instagram",
    accept_terms: "J'accepte les",
    terms_of_service: "conditions d'utilisation",
    and: 'et la',
    privacy_policy: 'politique de confidentialité',
    terms_required: "Vous devez accepter les conditions d'utilisation",
    all_fields_required: 'Tous les champs sont requis',
    phone_required: 'Le numéro de téléphone est obligatoire',
    complete_profile: 'Complétez votre profil pour continuer',
    choose_plan: 'Choisissez le plan qui vous convient le mieux',
    start_free_trial: "Commencer l'essai gratuit",
    continue: 'Continuer',
    grow_instagram: 'Faites grandir votre présence Instagram',
    automate_growth:
      'Automatisez votre croissance avec des outils intelligents et des analyses détaillées',
    select_plan_required: 'Veuillez sélectionner un plan pour continuer',
    feature_locked: 'Fonctionnalité verrouillée',
    select_plan_to_unlock:
      'Sélectionnez un plan pour débloquer cette fonctionnalité',
    view_plans: 'Voir les plans',
    undo_cancellation: 'Annuler la résiliation',
    invoice_history: 'Historique des factures',
    no_invoices: 'Aucune facture disponible',
    download_invoice: 'Télécharger la facture',
    invalid_username_format:
      "Format de nom d'utilisateur invalide. Utilisez uniquement des lettres, chiffres, points et underscores.",
    account_already_exists: 'Ce compte existe déjà',
    username_already_exists:
      "Ce nom d'utilisateur Instagram est déjà utilisé par un autre compte",
    payment_successful: 'Paiement réussi !',
    payment_success_message: 'Votre paiement a été traité avec succès.',
    page_not_found: 'Page non trouvée',
    page_not_found_description:
      "La page que vous recherchez n'existe pas ou a été déplacée.",
    go_back: 'Retour',
    return_home: "Retour à l'accueil",
    secure_connection: 'Connexion sécurisée',
    country: 'Pays de connexion',
    week: 'Semaine',
    week_number: 'Semaine {number}',
    amplr_ai_progress: "Progression de l'optimisation d'Amplr AI",
    amplr_ai_description:
      "L'optimisation se fait étape par étape afin de garantir une progression naturelle et sécurisée de votre compte.",
    target_quality_score: 'Score de qualité des cibles',
    target_quality_description:
      "Le score de qualité mesure la pertinence des cibles sélectionnées. Plus vous ajoutez de cibles pertinentes, plus le score augmente — et plus il est élevé, plus vous avez de chances d'obtenir des résultats concrets : des abonnés actifs, qualifiés et engagés.",
    invalid_credentials: 'Mot de passe incorrect',
    forgot_password: 'Mot de passe oublié ?',
    two_factor_auth: 'Double authentification',
    two_factor_description:
      "Saisissez le code que vous avez reçu par SMS, WhatsApp, e-mail ou via votre application d'authentification à deux facteurs (comme Google Authenticator).\n\n\nVeuillez noter que la réception du code peut prendre quelques minutes.",
    finalize_connection: 'Finaliser la connexion',
    two_factor_code: 'Code de double authentification',
    verify_2fa: 'Vérifier le code',
    two_factor_code_required: 'Le code de double authentification est requis',
    no_data_available: 'Aucune donnée disponible',
    welcome_back: 'Bon retour !',
    sign_in_to_continue: 'Connectez-vous pour continuer',
    dont_have_account: "Vous n'avez pas de compte ?",
    sign_up: 'Inscrivez-vous',
    welcome_back_to_amplr: 'Bienvenue sur Amplr',
    continue_growing_instagram:
      'Continuez à développer votre présence Instagram avec des outils automatisés et des analyses.',
    already_have_account: 'Vous avez déjà un compte ?',
    forgot_password_title: 'Réinitialiser votre mot de passe',
    check_your_email: 'Vérifiez votre boîte mail',
    reset_link_sent:
      "Un lien de réinitialisation a été envoyé à votre adresse e-mail. Cliquez sur le lien dans l'e-mail pour réinitialiser votre mot de passe.",
    back_to_login: 'Retour à la connexion',
    enter_email: 'Entrez votre adresse e-mail',
    sending: 'Envoi en cours...',
    send_reset_link: 'Envoyer le lien de réinitialisation',
    reset_your_password: 'Réinitialisez votre mot de passe',
    reset_password_description:
      'Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
    email_placeholder: 'Entrez votre adresse e-mail',
    first_name_placeholder: 'Entrez votre prénom',
    last_name_placeholder: 'Entrez votre nom',
    phone_placeholder: 'Entrez votre numéro de téléphone',
    current_password_placeholder: 'Entrez votre mot de passe actuel',
    new_password_placeholder: 'Entrez votre nouveau mot de passe',
    confirm_password_placeholder: 'Confirmez votre nouveau mot de passe',
    username_placeholder: "Entrez votre nom d'utilisateur",
    password_placeholder: 'Entrez votre mot de passe',
    please_wait_connection:
      'Veuillez patienter... la connexion de votre compte peut prendre quelques minutes.',
    invalid_reset_link: 'Lien de réinitialisation invalide',
    redirecting_to_login: 'Redirection vers la page de connexion...',
    reset_password: 'Réinitialiser le mot de passe',
    announcements: 'Annonces',
    new_announcement: 'Nouvelle annonce',
    announcement_title: "Titre de l'annonce",
    announcement_content: "Contenu de l'annonce",
    info: 'Information',
    important: 'Important',
    publish: 'Publier',
    no_announcements: 'Aucune annonce pour le moment',
    months: [
      'janvier',
      'février',
      'mars',
      'avril',
      'mai',
      'juin',
      'juillet',
      'août',
      'septembre',
      'octobre',
      'novembre',
      'décembre',
    ],
    days: [
      'dimanche',
      'lundi',
      'mardi',
      'mercredi',
      'jeudi',
      'vendredi',
      'samedi',
    ],
    date_format: 'Le {day} {date} {month} {year}',
    connection_status_connected: 'Connecté',
    connection_status_2fa: 'Double authentification requise',
    connection_status_failed: 'Non connecté',
    connection_status_pending: 'En attente',
    or: 'ou',
    continue_with_google: 'Continuer avec Google',
    reset_password_title: 'Mot de passe oublié ?',
    reset_password_description: 'Réinitialiser votre mot de passe Instagram.',
    reset_password_steps: 'Suivez ces étapes simples :',
    reset_password_step1:
      "1. Ouvrez l'application Instagram ou rendez-vous sur instagram.com.",
    reset_password_step2:
      "2. Cliquez sur « Mot de passe oublié ? » sur l'écran de connexion.",
    reset_password_step3:
      "3. Quand on vous demande une information de récupération, entrez uniquement votre nom d'utilisateur Instagram.",
    reset_password_step4:
      '4. Vous recevrez un lien pour réinitialiser le mot de passe associé à ce pseudo uniquement.',
    reset_password_step5:
      '5. Suivez le lien, choisissez un nouveau mot de passe, et vous pourrez vous reconnecter à votre compte.',
    reset_password_warning1: '❌ Ne mettez pas votre adresse e-mail.',
    reset_password_warning2: '❌ Ne mettez pas votre numéro de téléphone.',
    understood: 'Compris',
    cockpit: 'Cockpit',
    cancel_step1_title: 'Annuler mon abonnement',
    cancel_step2_title: 'Pourquoi souhaitez-vous annuler ?',
    cancel_special_offer_title: 'Vous avez débloqué une offre exceptionnelle',
    cancel_long_term:
      "L'optimisation Instagram est un processus à long terme. Annuler maintenant pourrait compromettre vos résultats.",
    cancel_lose_optimizations: 'Vous perdrez toutes les optimisations en cours',
    cancel_lose_progress: 'Votre progression sera perdue',
    cancel_lose_followers: 'Vous risquez de perdre des abonnés',
    cancel_restart_warning:
      'Si vous décidez de revenir plus tard, vous devrez tout recommencer depuis le début.',
    cancel_keep_subscription: 'Garder mon abonnement',
    cancel_proceed_anyway: 'Continuer quand même',
    cancel_reason_prompt:
      'Aidez-nous à nous améliorer en nous indiquant la raison de votre annulation :',
    cancel_reason_no_results: "Je n'ai pas obtenu les résultats escomptés",
    cancel_reason_not_understood:
      "Je n'ai pas compris comment utiliser le service",
    cancel_reason_budget: "C'est trop cher pour mon budget actuel",
    cancel_reason_no_need: "Je n'ai plus besoin du service",
    cancel_reason_too_complicated: 'Le service est trop compliqué à utiliser',
    cancel_reason_other: 'Autre raison',
    cancel_reason_specify: 'Veuillez préciser...',
    cancel_final_warning:
      "Vous êtes sur le point d'annuler votre abonnement. Cette action mettra fin à tous les services à la fin de votre période de facturation actuelle.",
    cancel_keep_subscription_final: 'Garder mon abonnement',
    cancel_confirm_final: 'Je confirme mon annulation',
    cancelling: 'Annulation en cours...',
    special_offer_title: 'Offre Spéciale Exclusive',
    special_offer_description:
      'Nous vous proposons une réduction exceptionnelle pour vous remercier de votre fidélité.',
    special_offer_duration: 'pendant 2 mois',
    accept_special_offer: "Accepter l'offre",
    applying_discount: 'Application de la réduction...',
    confirm_cancellation: 'Je confirme mon annulation',
    connection_required:
      "Ce compte n'est pas connecté. Pour que Amplr AI puisse fonctionner et générer des résultats, vous devez connecter votre compte dans les paramètres. Si vous avez besoin d'aide, n'hésitez pas à nous contacter.",
  },
  EN: {
    dashboard: 'Update',
    instagram_accounts: 'Instagram Accounts',
    referral: 'Referral',
    help_support: 'Help & Support',
    my_account: 'My Account',
    logout: 'Logout',
    add_account: 'Add Account',
    light_mode: 'Light Mode',
    dark_mode: 'Dark Mode',
    select_account: 'Select an Instagram account to view details',
    active: 'Active',
    paused: 'Paused',
    welcome: 'Welcome to your Update',
    invite_friends: 'Invite friends and earn rewards',
    manage_info: 'Manage your personal information',
    search_accounts: 'Search accounts...',
    search_targets: 'Search Instagram accounts...',
    add_multiple_targets: 'Add multiple targets (comma separated)',
    no_results: 'No results found',
    selected_targets: 'Selected Targets',
    followers: 'Followers',
    following: 'Following',
    posts: 'Posts',
    popular: 'Popular',
    current_plan: 'Current Plan',
    change_plan: 'Change Plan',
    start_now: 'Start for free',
    cancel_subscription: 'Cancel Subscription',
    cancel_subscription_confirm:
      'Are you sure you want to cancel your subscription?',
    cancel_subscription_warning:
      'Your subscription will be cancelled at the end of the current period.',
    per_month: '/month',
    welcome_dm: 'Welcome DM',
    welcome_dm_placeholder: 'Write your welcome message...',
    welcome_dm_description:
      "You can use the following variables in your custom messages:\n{{username}} for the username,\n{{full_name}} for the full name (or username if full name is not set)\n{{first_name}} for the recipient's first name.",
    save: 'Save',
    welcome_dm_saved: 'Message saved successfully',
    add_instagram_account: 'Add Instagram Account',
    select_plan: 'Select a Plan',
    connect_account: 'Connect Account',
    username: 'Username',
    password: 'Password',
    connect: 'Connect',
    back: 'Back',
    next: 'Next',
    username_required: 'Username is required',
    password_required: 'Password is required',
    delete_account_confirm: 'Delete Account',
    delete_account_warning:
      'Are you sure you want to delete this account? This action cannot be undone.',
    cancel: 'Cancel',
    delete: 'Delete',
    add: 'Add',
    verifying: 'Verifying...',
    connecting: 'Connecting...',
    please_wait: 'Please wait...',
    continue_now: 'Continue Now',
    return_to_dashboard: 'Return to Update',
    overview: 'Overview',
    targets: 'Targets',
    plans: 'Plans',
    welcome_dm_tab: 'Welcome DM',
    close_friends: 'Close Friends',
    close_friends_active:
      "The close friends feature is active and working normally, you don't need to do anything.",
    close_friends_description:
      "Followers are added progressively up to a maximum of 7,500 followers, in accordance with Instagram's limit. Once this threshold is reached, all followers are randomly integrated into the close friends list, ensuring fair rotation and visibility for everyone over time.",
    settings: 'Settings',
    account_settings: 'Account Settings',
    new_password: 'New Password',
    enter_new_password: 'Enter new password',
    update_password: 'Update Password',
    updating: 'Updating...',
    password_updated: 'Password updated successfully',
    profile_updated: 'Profile updated successfully',
    update_password_error: 'Error updating password',
    followers_evolution: 'Followers Evolution',
    followers_gained: 'Followers Gained',
    daily_gains: 'Daily Gains',
    free_account: 'Free Account',
    select_payment: 'Select Payment Method',
    card_information: 'Card Information',
    card_number: 'Card Number',
    expiration: 'Expiration',
    cvc: 'CVC',
    pay: 'Pay',
    processing: 'Processing...',
    invalid_plan: 'Invalid Plan',
    checkout_error: 'An error occurred during payment. Please try again.',
    monthly: 'Monthly',
    annual: 'Annual',
    save_annually: 'Save up to {savings} per year',
    personal_info: 'Personal Information',
    email: 'Email Address',
    first_name: 'First Name',
    last_name: 'Last Name',
    phone: 'Phone',
    save_changes: 'Save Changes',
    saving: 'Saving...',
    change_password: 'Change Password',
    current_password: 'Current Password',
    confirm_password: 'Confirm Password',
    changing: 'Changing...',
    password_min_length: 'Password must be at least 6 characters long',
    passwords_not_match: 'Passwords do not match',
    sign_in: 'Sign In',
    connect_instagram: 'Connect your Instagram Account',
    enter_instagram_username: 'Enter your Instagram username to get started',
    instagram_username: 'Instagram Username',
    accept_terms: 'I accept the',
    terms_of_service: 'Terms of Service',
    and: 'and',
    privacy_policy: 'Privacy Policy',
    terms_required: 'You must accept the terms of service',
    all_fields_required: 'All fields are required',
    complete_profile: 'Complete your profile to continue',
    choose_plan: 'Choose the plan that suits you best',
    start_free_trial: 'Start Free Trial',
    continue: 'Continue',
    grow_instagram: 'Grow your Instagram presence',
    automate_growth:
      'Automate your growth with smart tools and detailed analytics',
    select_plan_required: 'Please select a plan to continue',
    feature_locked: 'Feature Locked',
    select_plan_to_unlock: 'Select a plan to unlock this feature',
    view_plans: 'View Plans',
    undo_cancellation: 'Undo Cancellation',
    invoice_history: 'Invoice History',
    no_invoices: 'No invoices available',
    download_invoice: 'Download Invoice',
    invalid_username_format:
      'Invalid username format. Use only letters, numbers, dots and underscores.',
    account_already_exists: 'This account already exists',
    username_already_exists:
      'This Instagram username is already used by another account',
    payment_successful: 'Payment successful!',
    payment_success_message: 'Your payment has been processed successfully.',
    page_not_found: 'Page Not Found',
    page_not_found_description:
      'The page you are looking for does not exist or has been moved.',
    go_back: 'Go Back',
    return_home: 'Return Home',
    secure_connection: 'Secure Connection',
    country: 'Connection Country',
    week: 'Week',
    week_number: 'Week {number}',
    amplr_ai_progress: 'Amplr AI Optimization Progress',
    amplr_ai_description:
      'Optimization is done step by step to ensure natural and secure progression of your account.',
    target_quality_score: 'Target Quality Score',
    target_quality_description:
      'The quality score measures the relevance of selected targets. The more relevant targets you add, the higher the score — and the higher it is, the more likely you are to get concrete results: active, qualified, and engaged followers.',
    invalid_credentials: 'Incorrect password',
    forgot_password: 'Forgot password?',
    two_factor_auth: 'Two-Factor Authentication',
    two_factor_description:
      'Enter the code you received via SMS, WhatsApp, email, or your two-factor authentication app (like Google Authenticator).\n\n\nPlease note that it may take a few minutes to receive the code.',
    finalize_connection: 'Finalize Connection',
    two_factor_code: 'Two-Factor Authentication Code',
    verify_2fa: 'Verify Code',
    two_factor_code_required: 'Two-factor authentication code is required',
    no_data_available: 'No data available',
    welcome_back: 'Welcome back!',
    sign_in_to_continue: 'Sign in to continue',
    dont_have_account: "Don't have an account?",
    sign_up: 'Sign up',
    welcome_back_to_amplr: 'Welcome back to Amplr',
    continue_growing_instagram:
      'Continue growing your Instagram presence with automated tools and analytics.',
    already_have_account: 'Already have an account?',
    forgot_password_title: 'Reset your password',
    check_your_email: 'Check your email',
    reset_link_sent:
      'A password reset link has been sent to your email address. Click the link in the email to reset your password.',
    back_to_login: 'Back to login',
    enter_email: 'Enter your email address',
    sending: 'Sending...',
    send_reset_link: 'Send reset link',
    reset_your_password: 'Reset your password',
    reset_password_description:
      "Enter your email address and we'll send you a link to reset your password.",
    email_placeholder: 'Enter your email address',
    first_name_placeholder: 'Enter your first name',
    last_name_placeholder: 'Enter your last name',
    phone_placeholder: 'Enter your phone number',
    current_password_placeholder: 'Enter your current password',
    new_password_placeholder: 'Enter your new password',
    confirm_password_placeholder: 'Confirm your new password',
    username_placeholder: 'Enter your username',
    password_placeholder: 'Enter your password',
    please_wait_connection:
      'Please wait... connecting your account may take a few minutes.',
    invalid_reset_link: 'Invalid reset link',
    redirecting_to_login: 'Redirecting to login page...',
    reset_password: 'Reset Password',
    announcements: 'Announcements',
    new_announcement: 'New Announcement',
    announcement_title: 'Announcement Title',
    announcement_content: 'Announcement Content',
    info: 'Information',
    important: 'Important',
    publish: 'Publish',
    no_announcements: 'No announcements yet',
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    days: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
    date_format: '{day}, {month} {date}, {year}',
    connection_status_connected: 'Connected',
    connection_status_2fa: '2FA Required',
    connection_status_failed: 'Not Connected',
    connection_status_pending: 'Pending',
    or: 'or',
    continue_with_google: 'Continue with Google',
    cockpit: 'Cockpit',
    cancel_step1_title: 'Cancel Subscription',
    cancel_step2_title: 'Why do you want to cancel?',
    cancel_special_offer_title: "You've unlocked an exclusive offer",
    cancel_long_term:
      'Instagram optimization is a long-term process. Canceling now could compromise your results.',
    cancel_lose_optimizations: "You'll lose all ongoing optimizations",
    cancel_lose_progress: 'Your progress will be lost',
    cancel_lose_followers: 'You risk losing followers',
    cancel_restart_warning:
      "If you decide to come back later, you'll have to start over from the beginning.",
    cancel_keep_subscription: 'Keep my subscription',
    cancel_proceed_anyway: 'Proceed anyway',
    cancel_reason_prompt: "Help us improve by telling us why you're canceling:",
    cancel_reason_no_results: "I didn't get the expected results",
    cancel_reason_not_understood: "I didn't understand how to use the service",
    cancel_reason_budget: "It's too expensive for my current budget",
    cancel_reason_no_need: 'I no longer need the service',
    cancel_reason_too_complicated: 'The service is too complicated to use',
    cancel_reason_other: 'Other reason',
    cancel_reason_specify: 'Please specify...',
    cancel_final_warning:
      'You are about to cancel your subscription. This action will end all services at the end of your current billing period.',
    cancel_keep_subscription_final: 'Keep my subscription',
    cancel_confirm_final: 'I confirm my cancellation',
    cancelling: 'Cancelling...',
    special_offer_title: 'Exclusive Special Offer',
    special_offer_description:
      'We offer you an exceptional discount to thank you for your loyalty.',
    special_offer_duration: 'for 2 months',
    accept_special_offer: 'Accept offer',
    applying_discount: 'Applying discount...',
    confirm_cancellation: 'I confirm my cancellation',
    connection_required:
      "This account is not connected. For Amplr AI to work and generate results, you need to connect your account in settings. If you need help, don't hesitate to contact us.",
  },
  ES: {
    dashboard: 'Actualización',
    instagram_accounts: 'Cuentas de Instagram',
    referral: 'Referidos',
    help_support: 'Ayuda y soporte',
    my_account: 'Mi cuenta',
    logout: 'Cerrar sesión',
    add_account: 'Agregar cuenta',
    light_mode: 'Modo claro',
    dark_mode: 'Modo oscuro',
    select_account: 'Selecciona una cuenta de Instagram para ver detalles',
    active: 'Activo',
    paused: 'Pausado',
    welcome: 'Bienvenido a tu Actualización',
    invite_friends: 'Invita amigos y gana recompensas',
    manage_info: 'Gestiona tu información personal',
    search_accounts: 'Buscar cuentas...',
    search_targets: 'Buscar cuentas de Instagram...',
    add_multiple_targets: 'Agregar múltiples objetivos (separados por comas)',
    no_results: 'No se encontraron resultados',
    selected_targets: 'Objetivos seleccionados',
    followers: 'Seguidores',
    following: 'Siguiendo',
    posts: 'Publicaciones',
    popular: 'Popular',
    current_plan: 'Plan actual',
    change_plan: 'Cambiar plan',
    start_now: 'Empieza gratis',
    cancel_subscription: 'Cancelar suscripción',
    cancel_subscription_confirm:
      '¿Estás seguro de que quieres cancelar tu suscripción?',
    cancel_subscription_warning:
      'Tu suscripción será cancelada al final del período actual.',
    per_month: '/mes',
    welcome_dm: 'Mensaje de bienvenida',
    welcome_dm_placeholder: 'Escribe tu mensaje de bienvenida...',
    welcome_dm_description:
      'Puedes usar las siguientes variables en tus mensajes personalizados:\n{{username}} para el nombre de usuario,\n{{full_name}} para el nombre completo (o nombre de usuario si no está configurado)\n{{first_name}} para el primer nombre del destinatario.',
    save: 'Guardar',
    welcome_dm_saved: 'Mensaje guardado exitosamente',
    add_instagram_account: 'Agregar cuenta de Instagram',
    select_plan: 'Seleccionar un plan',
    connect_account: 'Conectar cuenta',
    username: 'Nombre de usuario',
    password: 'Contraseña',
    connect: 'Conectar',
    back: 'Atrás',
    next: 'Siguiente',
    username_required: 'El nombre de usuario es requerido',
    password_required: 'La contraseña es requerida',
    delete_account_confirm: 'Eliminar cuenta',
    delete_account_warning:
      '¿Estás seguro de que quieres eliminar esta cuenta? Esta acción no se puede deshacer.',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    add: 'Agregar',
    verifying: 'Verificando...',
    connecting: 'Conectando...',
    please_wait: 'Por favor espera...',
    continue_now: 'Continuar ahora',
    return_to_dashboard: 'Volver a la Actualización',
    overview: 'Resumen',
    targets: 'Objetivos',
    plans: 'Planes',
    welcome_dm_tab: 'Mensaje de bienvenida',
    close_friends: 'Amigos cercanos',
    close_friends_active:
      'La función de amigos cercanos está activa y funcionando normalmente, no necesitas hacer nada.',
    close_friends_description:
      'Los seguidores se agregan progresivamente hasta un máximo de 7,500 seguidores, de acuerdo con el límite de Instagram. Una vez alcanzado este umbral, todos los seguidores se integran aleatoriamente en la lista de amigos cercanos, asegurando una rotación justa y visibilidad para todos con el tiempo.',
    settings: 'Configuración',
    account_settings: 'Configuración de cuenta',
    new_password: 'Nueva contraseña',
    enter_new_password: 'Ingresa nueva contraseña',
    update_password: 'Actualizar contraseña',
    updating: 'Actualizando...',
    password_updated: 'Contraseña actualizada exitosamente',
    profile_updated: 'Perfil actualizado exitosamente',
    update_password_error: 'Error al actualizar contraseña',
    followers_evolution: 'Evolución de seguidores',
    followers_gained: 'Seguidores ganados',
    daily_gains: 'Ganancias diarias',
    free_account: 'Cuenta gratuita',
    select_payment: 'Seleccionar método de pago',
    card_information: 'Información de tarjeta',
    card_number: 'Número de tarjeta',
    expiration: 'Expiración',
    cvc: 'CVC',
    pay: 'Pagar',
    processing: 'Procesando...',
    invalid_plan: 'Plan inválido',
    checkout_error:
      'Ocurrió un error durante el pago. Por favor intenta de nuevo.',
    monthly: 'Mensual',
    annual: 'Anual',
    save_annually: 'Ahorra hasta {savings} por año',
    personal_info: 'Información personal',
    email: 'Dirección de correo',
    first_name: 'Nombre',
    last_name: 'Apellido',
    phone: 'Teléfono',
    save_changes: 'Guardar cambios',
    saving: 'Guardando...',
    change_password: 'Cambiar contraseña',
    current_password: 'Contraseña actual',
    confirm_password: 'Confirmar contraseña',
    changing: 'Cambiando...',
    password_min_length: 'La contraseña debe tener al menos 6 caracteres',
    passwords_not_match: 'Las contraseñas no coinciden',
    sign_in: 'Iniciar sesión',
    connect_instagram: 'Conecta tu cuenta de Instagram',
    enter_instagram_username:
      'Ingresa tu nombre de usuario de Instagram para comenzar',
    instagram_username: 'Nombre de usuario de Instagram',
    accept_terms: 'Acepto los',
    terms_of_service: 'Términos de servicio',
    and: 'y la',
    privacy_policy: 'Política de privacidad',
    terms_required: 'Debes aceptar los términos de servicio',
    all_fields_required: 'Todos los campos son requeridos',
    complete_profile: 'Completa tu perfil para continuar',
    choose_plan: 'Elige el plan que mejor se adapte a ti',
    start_free_trial: 'Comenzar prueba gratuita',
    continue: 'Continuar',
    grow_instagram: 'Haz crecer tu presencia en Instagram',
    automate_growth:
      'Automatiza tu crecimiento con herramientas inteligentes y análisis detallados',
    select_plan_required: 'Por favor selecciona un plan para continuar',
    feature_locked: 'Función bloqueada',
    select_plan_to_unlock: 'Selecciona un plan para desbloquear esta función',
    view_plans: 'Ver planes',
    undo_cancellation: 'Deshacer cancelación',
    invoice_history: 'Historial de facturas',
    no_invoices: 'No hay facturas disponibles',
    download_invoice: 'Descargar factura',
    invalid_username_format:
      'Formato de nombre de usuario inválido. Usa solo letras, números, puntos y guiones bajos.',
    account_already_exists: 'Esta cuenta ya existe',
    username_already_exists:
      'Este nombre de usuario de Instagram ya está siendo usado por otra cuenta',
    payment_successful: '¡Pago exitoso!',
    payment_success_message: 'Tu pago ha sido procesado exitosamente.',
    page_not_found: 'Página no encontrada',
    page_not_found_description:
      'La página que buscas no existe o ha sido movida.',
    go_back: 'Volver',
    return_home: 'Volver al inicio',
    secure_connection: 'Conexión segura',
    country: 'País de conexión',
    week: 'Semana',
    week_number: 'Semana {number}',
    amplr_ai_progress: 'Progreso de optimización de Amplr AI',
    amplr_ai_description:
      'La optimización se hace paso a paso para asegurar una progresión natural y segura de tu cuenta.',
    target_quality_score: 'Puntuación de calidad de objetivos',
    target_quality_description:
      'La puntuación de calidad mide la relevancia de los objetivos seleccionados. Mientras más objetivos relevantes agregues, mayor será la puntuación — y mientras más alta sea, más probabilidades tienes de obtener resultados concretos: seguidores activos, calificados y comprometidos.',
    invalid_credentials: 'Contraseña incorrecta',
    forgot_password: '¿Olvidaste tu contraseña?',
    two_factor_auth: 'Autenticación de dos factores',
    two_factor_description:
      'Ingresa el código que recibiste por SMS, WhatsApp, correo electrónico o tu aplicación de autenticación de dos factores (como Google Authenticator).\n\n\nTen en cuenta que puede tomar unos minutos recibir el código.',
    finalize_connection: 'Finalizar conexión',
    two_factor_code: 'Código de autenticación de dos factores',
    verify_2fa: 'Verificar código',
    two_factor_code_required:
      'El código de autenticación de dos factores es requerido',
    no_data_available: 'No hay datos disponibles',
    welcome_back: '¡Bienvenido de vuelta!',
    sign_in_to_continue: 'Inicia sesión para continuar',
    dont_have_account: '¿No tienes una cuenta?',
    sign_up: 'Regístrate',
    welcome_back_to_amplr: 'Bienvenido de vuelta a Amplr',
    continue_growing_instagram:
      'Continúa haciendo crecer tu presencia en Instagram con herramientas automatizadas y análisis.',
    already_have_account: '¿Ya tienes una cuenta?',
    forgot_password_title: 'Restablecer tu contraseña',
    check_your_email: 'Revisa tu correo electrónico',
    reset_link_sent:
      'Se ha enviado un enlace de restablecimiento a tu dirección de correo electrónico. Haz clic en el enlace del correo para restablecer tu contraseña.',
    back_to_login: 'Volver al inicio de sesión',
    enter_email: 'Ingresa tu dirección de correo electrónico',
    sending: 'Enviando...',
    send_reset_link: 'Enviar enlace de restablecimiento',
    reset_your_password: 'Restablece tu contraseña',
    reset_password_description:
      'Ingresa tu dirección de correo electrónico y te enviaremos un enlace para restablecer tu contraseña.',
    email_placeholder: 'Ingresa tu dirección de correo electrónico',
    first_name_placeholder: 'Ingresa tu nombre',
    last_name_placeholder: 'Ingresa tu apellido',
    phone_placeholder: 'Ingresa tu número de teléfono',
    current_password_placeholder: 'Ingresa tu contraseña actual',
    new_password_placeholder: 'Ingresa tu nueva contraseña',
    confirm_password_placeholder: 'Confirma tu nueva contraseña',
    username_placeholder: 'Ingresa tu nombre de usuario',
    password_placeholder: 'Ingresa tu contraseña',
    please_wait_connection:
      'Por favor espera... conectar tu cuenta puede tomar unos minutos.',
    invalid_reset_link: 'Enlace de restablecimiento inválido',
    redirecting_to_login: 'Redirigiendo a la página de inicio de sesión...',
    reset_password: 'Restablecer contraseña',
    announcements: 'Anuncios',
    new_announcement: 'Nuevo anuncio',
    announcement_title: 'Título del anuncio',
    announcement_content: 'Contenido del anuncio',
    info: 'Información',
    important: 'Importante',
    publish: 'Publicar',
    no_announcements: 'No hay anuncios aún',
    months: [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre',
    ],
    days: [
      'domingo',
      'lunes',
      'martes',
      'miércoles',
      'jueves',
      'viernes',
      'sábado',
    ],
    date_format: '{day} {date} de {month} de {year}',
    connection_status_connected: 'Conectado',
    connection_status_2fa: '2FA requerido',
    connection_status_failed: 'No conectado',
    connection_status_pending: 'Pendiente',
    or: 'o',
    continue_with_google: 'Continuar con Google',
    cockpit: 'Cabina',
    cancel_step1_title: 'Cancelar suscripción',
    cancel_step2_title: '¿Por qué quieres cancelar?',
    cancel_special_offer_title: 'Has desbloqueado una oferta exclusiva',
    cancel_long_term:
      'La optimización de Instagram es un proceso a largo plazo. Cancelar ahora podría comprometer tus resultados.',
    cancel_lose_optimizations: 'Perderás todas las optimizaciones en curso',
    cancel_lose_progress: 'Tu progreso se perderá',
    cancel_lose_followers: 'Corres el riesgo de perder seguidores',
    cancel_restart_warning:
      'Si decides volver más tarde, tendrás que empezar de nuevo desde el principio.',
    cancel_keep_subscription: 'Mantener mi suscripción',
    cancel_proceed_anyway: 'Proceder de todos modos',
    cancel_reason_prompt:
      'Ayúdanos a mejorar diciéndonos por qué estás cancelando:',
    cancel_reason_no_results: 'No obtuve los resultados esperados',
    cancel_reason_not_understood: 'No entendí cómo usar el servicio',
    cancel_reason_budget: 'Es muy caro para mi presupuesto actual',
    cancel_reason_no_need: 'Ya no necesito el servicio',
    cancel_reason_too_complicated: 'El servicio es muy complicado de usar',
    cancel_reason_other: 'Otra razón',
    cancel_reason_specify: 'Por favor especifica...',
    cancel_final_warning:
      'Estás a punto de cancelar tu suscripción. Esta acción terminará todos los servicios al final de tu período de facturación actual.',
    cancel_keep_subscription_final: 'Mantener mi suscripción',
    cancel_confirm_final: 'Confirmo mi cancelación',
    cancelling: 'Cancelando...',
    special_offer_title: 'Oferta especial exclusiva',
    special_offer_description:
      'Te ofrecemos un descuento excepcional para agradecerte tu lealtad.',
    special_offer_duration: 'por 2 meses',
    accept_special_offer: 'Aceptar oferta',
    applying_discount: 'Aplicando descuento...',
    confirm_cancellation: 'Confirmo mi cancelación',
    connection_required:
      'Esta cuenta no está conectada. Para que Amplr AI funcione y genere resultados, debes conectar tu cuenta en la configuración. Si necesitas ayuda, no dudes en contactarnos.',
  },
  RU: {
    dashboard: 'Обновление',
    instagram_accounts: 'Аккаунты Instagram',
    referral: 'Реферальная программа',
    help_support: 'Помощь и поддержка',
    my_account: 'Мой аккаунт',
    logout: 'Выйти',
    add_account: 'Добавить аккаунт',
    light_mode: 'Светлая тема',
    dark_mode: 'Темная тема',
    select_account: 'Выберите аккаунт Instagram для просмотра деталей',
    active: 'Активный',
    paused: 'Приостановлен',
    welcome: 'Добро пожаловать в ваше Обновление',
    invite_friends: 'Приглашайте друзей и получайте награды',
    manage_info: 'Управляйте вашей личной информацией',
    search_accounts: 'Поиск аккаунтов...',
    search_targets: 'Поиск аккаунтов Instagram...',
    add_multiple_targets: 'Добавить несколько целей (через запятую)',
    no_results: 'Результаты не найдены',
    selected_targets: 'Выбранные цели',
    followers: 'Подписчики',
    following: 'Подписки',
    posts: 'Посты',
    popular: 'Популярный',
    current_plan: 'Текущий план',
    change_plan: 'Изменить план',
    start_now: 'Начать бесплатно',
    cancel_subscription: 'Отменить подписку',
    cancel_subscription_confirm: 'Вы уверены, что хотите отменить подписку?',
    cancel_subscription_warning:
      'Ваша подписка будет отменена в конце текущего периода.',
    per_month: '/месяц',
    welcome_dm: 'Приветственное сообщение',
    welcome_dm_placeholder: 'Напишите ваше приветственное сообщение...',
    welcome_dm_description:
      'Вы можете использовать следующие переменные в ваших персонализированных сообщениях:\n{{username}} для имени пользователя,\n{{full_name}} для полного имени (или имени пользователя, если полное имя не установлено)\n{{first_name}} для имени получателя.',
    save: 'Сохранить',
    welcome_dm_saved: 'Сообщение успешно сохранено',
    add_instagram_account: 'Добавить аккаунт Instagram',
    select_plan: 'Выбрать план',
    connect_account: 'Подключить аккаунт',
    username: 'Имя пользователя',
    password: 'Пароль',
    connect: 'Подключить',
    back: 'Назад',
    next: 'Далее',
    username_required: 'Имя пользователя обязательно',
    password_required: 'Пароль обязателен',
    delete_account_confirm: 'Удалить аккаунт',
    delete_account_warning:
      'Вы уверены, что хотите удалить этот аккаунт? Это действие нельзя отменить.',
    cancel: 'Отмена',
    delete: 'Удалить',
    add: 'Добавить',
    verifying: 'Проверка...',
    connecting: 'Подключение...',
    please_wait: 'Пожалуйста, подождите...',
    continue_now: 'Продолжить сейчас',
    return_to_dashboard: 'Вернуться к Обновлению',
    overview: 'Обзор',
    targets: 'Цели',
    plans: 'Планы',
    welcome_dm_tab: 'Приветственное сообщение',
    close_friends: 'Близкие друзья',
    close_friends_active:
      'Функция близких друзей активна и работает нормально, вам ничего не нужно делать.',
    close_friends_description:
      'Подписчики добавляются постепенно до максимума 7,500 подписчиков, в соответствии с ограничением Instagram. Как только этот порог достигнут, все подписчики случайным образом интегрируются в список близких друзей, обеспечивая справедливую ротацию и видимость для всех со временем.',
    settings: 'Настройки',
    account_settings: 'Настройки аккаунта',
    new_password: 'Новый пароль',
    enter_new_password: 'Введите новый пароль',
    update_password: 'Обновить пароль',
    updating: 'Обновление...',
    password_updated: 'Пароль успешно обновлен',
    profile_updated: 'Профиль успешно обновлен',
    update_password_error: 'Ошибка обновления пароля',
    followers_evolution: 'Эволюция подписчиков',
    followers_gained: 'Подписчики получены',
    daily_gains: 'Ежедневные приросты',
    free_account: 'Бесплатный аккаунт',
    select_payment: 'Выберите способ оплаты',
    card_information: 'Информация о карте',
    card_number: 'Номер карты',
    expiration: 'Срок действия',
    cvc: 'CVC',
    pay: 'Оплатить',
    processing: 'Обработка...',
    invalid_plan: 'Недействительный план',
    checkout_error:
      'Произошла ошибка при оплате. Пожалуйста, попробуйте снова.',
    monthly: 'Ежемесячно',
    annual: 'Ежегодно',
    save_annually: 'Экономьте до {savings} в год',
    personal_info: 'Личная информация',
    email: 'Адрес электронной почты',
    first_name: 'Имя',
    last_name: 'Фамилия',
    phone: 'Телефон',
    save_changes: 'Сохранить изменения',
    saving: 'Сохранение...',
    change_password: 'Изменить пароль',
    current_password: 'Текущий пароль',
    confirm_password: 'Подтвердить пароль',
    changing: 'Изменение...',
    password_min_length: 'Пароль должен содержать не менее 6 символов',
    passwords_not_match: 'Пароли не совпадают',
    sign_in: 'Войти',
    connect_instagram: 'Подключите ваш аккаунт Instagram',
    enter_instagram_username:
      'Введите ваше имя пользователя Instagram для начала',
    instagram_username: 'Имя пользователя Instagram',
    accept_terms: 'Я принимаю',
    terms_of_service: 'Условия использования',
    and: 'и',
    privacy_policy: 'Политику конфиденциальности',
    terms_required: 'Вы должны принять условия использования',
    all_fields_required: 'Все поля обязательны',
    complete_profile: 'Заполните ваш профиль для продолжения',
    choose_plan: 'Выберите план, который вам больше всего подходит',
    start_free_trial: 'Начать бесплатную пробную версию',
    continue: 'Продолжить',
    grow_instagram: 'Развивайте ваше присутствие в Instagram',
    automate_growth:
      'Автоматизируйте ваш рост с помощью умных инструментов и детальной аналитики',
    select_plan_required: 'Пожалуйста, выберите план для продолжения',
    feature_locked: 'Функция заблокирована',
    select_plan_to_unlock: 'Выберите план для разблокировки этой функции',
    view_plans: 'Посмотреть планы',
    undo_cancellation: 'Отменить отмену',
    invoice_history: 'История счетов',
    no_invoices: 'Нет доступных счетов',
    download_invoice: 'Скачать счет',
    invalid_username_format:
      'Недействительный формат имени пользователя. Используйте только буквы, цифры, точки и подчеркивания.',
    account_already_exists: 'Этот аккаунт уже существует',
    username_already_exists:
      'Это имя пользователя Instagram уже используется другим аккаунтом',
    payment_successful: 'Оплата прошла успешно!',
    payment_success_message: 'Ваш платеж был успешно обработан.',
    page_not_found: 'Страница не найдена',
    page_not_found_description:
      'Страница, которую вы ищете, не существует или была перемещена.',
    go_back: 'Назад',
    return_home: 'Вернуться домой',
    secure_connection: 'Безопасное соединение',
    country: 'Страна подключения',
    week: 'Неделя',
    week_number: 'Неделя {number}',
    amplr_ai_progress: 'Прогресс оптимизации Amplr AI',
    amplr_ai_description:
      'Оптимизация выполняется пошагово для обеспечения естественного и безопасного развития вашего аккаунта.',
    target_quality_score: 'Оценка качества целей',
    target_quality_description:
      'Оценка качества измеряет релевантность выбранных целей. Чем больше релевантных целей вы добавляете, тем выше оценка — и чем она выше, тем больше вероятность получить конкретные результаты: активных, квалифицированных и вовлеченных подписчиков.',
    invalid_credentials: 'Неверный пароль',
    forgot_password: 'Забыли пароль?',
    two_factor_auth: 'Двухфакторная аутентификация',
    two_factor_description:
      'Введите код, который вы получили по SMS, WhatsApp, электронной почте или через ваше приложение двухфакторной аутентификации (например, Google Authenticator).\n\n\nОбратите внимание, что получение кода может занять несколько минут.',
    finalize_connection: 'Завершить подключение',
    two_factor_code: 'Код двухфакторной аутентификации',
    verify_2fa: 'Проверить код',
    two_factor_code_required: 'Код двухфакторной аутентификации обязателен',
    no_data_available: 'Нет доступных данных',
    welcome_back: 'Добро пожаловать обратно!',
    sign_in_to_continue: 'Войдите для продолжения',
    dont_have_account: 'Нет аккаунта?',
    sign_up: 'Зарегистрироваться',
    welcome_back_to_amplr: 'Добро пожаловать обратно в Amplr',
    continue_growing_instagram:
      'Продолжайте развивать ваше присутствие в Instagram с помощью автоматизированных инструментов и аналитики.',
    already_have_account: 'Уже есть аккаунт?',
    forgot_password_title: 'Сбросить ваш пароль',
    check_your_email: 'Проверьте вашу электронную почту',
    reset_link_sent:
      'Ссылка для сброса пароля была отправлена на ваш адрес электронной почты. Нажмите на ссылку в письме, чтобы сбросить пароль.',
    back_to_login: 'Назад к входу',
    enter_email: 'Введите ваш адрес электронной почты',
    sending: 'Отправка...',
    send_reset_link: 'Отправить ссылку для сброса',
    reset_your_password: 'Сбросьте ваш пароль',
    reset_password_description:
      'Введите ваш адрес электронной почты, и мы отправим вам ссылку для сброса пароля.',
    email_placeholder: 'Введите ваш адрес электронной почты',
    first_name_placeholder: 'Введите ваше имя',
    last_name_placeholder: 'Введите вашу фамилию',
    phone_placeholder: 'Введите ваш номер телефона',
    current_password_placeholder: 'Введите ваш текущий пароль',
    new_password_placeholder: 'Введите ваш новый пароль',
    confirm_password_placeholder: 'Подтвердите ваш новый пароль',
    username_placeholder: 'Введите ваше имя пользователя',
    password_placeholder: 'Введите ваш пароль',
    please_wait_connection:
      'Пожалуйста, подождите... подключение вашего аккаунта может занять несколько минут.',
    invalid_reset_link: 'Недействительная ссылка для сброса',
    redirecting_to_login: 'Перенаправление на страницу входа...',
    reset_password: 'Сбросить пароль',
    announcements: 'Объявления',
    new_announcement: 'Новое объявление',
    announcement_title: 'Заголовок объявления',
    announcement_content: 'Содержание объявления',
    info: 'Информация',
    important: 'Важно',
    publish: 'Опубликовать',
    no_announcements: 'Пока нет объявлений',
    months: [
      'января',
      'февраля',
      'марта',
      'апреля',
      'мая',
      'июня',
      'июля',
      'августа',
      'сентября',
      'октября',
      'ноября',
      'декабря',
    ],
    days: [
      'воскресенье',
      'понедельник',
      'вторник',
      'среда',
      'четверг',
      'пятница',
      'суббота',
    ],
    date_format: '{day}, {date} {month} {year}',
    connection_status_connected: 'Подключен',
    connection_status_2fa: '2FA требуется',
    connection_status_failed: 'Не подключен',
    connection_status_pending: 'В ожидании',
    or: 'или',
    continue_with_google: 'Продолжить с Google',
    cockpit: 'Кабина',
    cancel_step1_title: 'Отменить подписку',
    cancel_step2_title: 'Почему вы хотите отменить?',
    cancel_special_offer_title: 'Вы разблокировали эксклюзивное предложение',
    cancel_long_term:
      'Оптимизация Instagram - это долгосрочный процесс. Отмена сейчас может поставить под угрозу ваши результаты.',
    cancel_lose_optimizations: 'Вы потеряете все текущие оптимизации',
    cancel_lose_progress: 'Ваш прогресс будет потерян',
    cancel_lose_followers: 'Вы рискуете потерять подписчиков',
    cancel_restart_warning:
      'Если вы решите вернуться позже, вам придется начинать все сначала.',
    cancel_keep_subscription: 'Сохранить мою подписку',
    cancel_proceed_anyway: 'Все равно продолжить',
    cancel_reason_prompt:
      'Помогите нам улучшиться, сказав нам, почему вы отменяете:',
    cancel_reason_no_results: 'Я не получил ожидаемых результатов',
    cancel_reason_not_understood: 'Я не понял, как использовать сервис',
    cancel_reason_budget: 'Это слишком дорого для моего текущего бюджета',
    cancel_reason_no_need: 'Мне больше не нужен сервис',
    cancel_reason_too_complicated: 'Сервис слишком сложен в использовании',
    cancel_reason_other: 'Другая причина',
    cancel_reason_specify: 'Пожалуйста, уточните...',
    cancel_final_warning:
      'Вы собираетесь отменить вашу подписку. Это действие завершит все услуги в конце вашего текущего расчетного периода.',
    cancel_keep_subscription_final: 'Сохранить мою подписку',
    cancel_confirm_final: 'Я подтверждаю мою отмену',
    cancelling: 'Отмена...',
    special_offer_title: 'Эксклюзивное специальное предложение',
    special_offer_description:
      'Мы предлагаем вам исключительную скидку в знак благодарности за вашу лояльность.',
    special_offer_duration: 'на 2 месяца',
    accept_special_offer: 'Принять предложение',
    applying_discount: 'Применение скидки...',
    confirm_cancellation: 'Я подтверждаю мою отмену',
    connection_required:
      'Этот аккаунт не подключен. Для работы Amplr AI и получения результатов необходимо подключить ваш аккаунт в настройках. Если вам нужна помощь, не стесняйтесь обращаться к нам.',
  },
};